import { Dropdown, DropdownButton } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import KButton from '../../components/KButton'
import { hideKAlert, setUserAccess } from '../../helpers'
import { getKycCheckVariant } from '../../helpers/stammdaten.helper'
import { t } from '../../locale'
import { Client, UserAccess } from '../../react-app-env'
import { useEffect, useState } from 'react'
import { validatePinCode } from '../../service/client'
import KAccess from '../../components/KAccess'
import ClientNotesModal from './ClientNotesModal'
interface ClientActionButtonsProps {
  client: Client
  userAccess: UserAccess
  clientStatusParam: string | null
  /** Seeded from the batched client-notes summary; kept in sync locally after edits. */
  hasNotes: boolean
  layout: 'card' | 'table'
  openDropdownUp?: boolean
  kycCheckEnabled: boolean
  amlSearchEnabled: boolean
  onCheck: (client: Client) => void
  onAmlCheck: (client: Client) => void
  onView: (client: Client) => void
  onSurveyForm: (clientId: string, isPerson: number) => void
  onDeactivate: (client: Client) => void
  onDelete: (clientNumber: number, clientId: string) => void
}

function ClientActionButtons({
  client,
  userAccess,
  clientStatusParam,
  hasNotes: hasNotesInitial,
  layout,
  openDropdownUp = false,
  kycCheckEnabled,
  amlSearchEnabled,
  onCheck,
  onAmlCheck,
  onView,
  onSurveyForm,
  onDeactivate,
  onDelete,
}: ClientActionButtonsProps) {
  const navigate = useNavigate()
  const isAdmin = !!userAccess && userAccess.permissions.admin

  const [access, setAccess] = useState(false)
  const [notes, setNotes] = useState(false)
  const [hasNotes, setHasNotes] = useState(hasNotesInitial)

  useEffect(() => {
    setHasNotes(hasNotesInitial)
  }, [hasNotesInitial])

  const checkPin = async (pinCode: number) => {
    try {
      const res = await validatePinCode(pinCode)

      if (res?.userAccess) {
        setUserAccess(res.userAccess)
        setAccess(false)
      }
    } catch (err) {
      console.error('Error validating pin code:', err)
    }
  }

  return (
    <div
      className={
        layout === 'card'
          ? 'd-flex flex-wrap align-items-center gap-2 mt-4'
          : 'd-flex flex-nowrap gap-1'
      }
    >
      {isAdmin && client.active && (
        <>
          {kycCheckEnabled && (
            <KButton
              id={layout === 'table' ? 'shufaCheck' : undefined}
              variant={getKycCheckVariant(client.lastCheck, client.risk)}
              type='button'
              icon='check'
              className={'text-white'}
              title={t('check')}
              onClick={() => onCheck(client)}
            />
          )}

          {amlSearchEnabled && (
            <KButton
              variant={getKycCheckVariant(client.lastCheck, client.risk)}
              type='button'
              icon='check'
              className='text-white'
              title={t('check')}
              onClick={() => onAmlCheck(client)}
            />
          )}
        </>
      )}

      <KButton
        className='btn-user-view text-white'
        variant='collapse'
        icon='eye'
        title={t('view')}
        onClick={() => onView(client)}
      />

      {client.active && (
        <KButton
          className='btn-user-view'
          icon='pencil-square'
          variant={client.surveyFormFinished ? 'success' : 'warning'}
          title={t('Erhebungsbogen')}
          onClick={() => onSurveyForm(client._id, client.isPerson)}
        />
      )}

      <KButton
        variant='outline-secondary'
        icon='folder2-open'
        title={t('viewDocuments')}
        className={layout === 'table' ? 'mt-1' : undefined}
        onClick={() => {
          if (!client.clientNumber) {
            alert(t('addClientNumberFirst'))
            return
          }
          localStorage.setItem('clientId', client._id)
          navigate(`/client/documents/${client.clientNumber}`)
        }}
      />

      <KButton
        variant={hasNotes ? 'success' : 'primary'}
        icon='justify'
        title={t('clientNotes')}
        className={layout === 'table' ? 'mt-1' : undefined}
        onClick={() => setNotes(true)}
      />

      {isAdmin &&
        (layout === 'card' ? (
          <div className='ms-auto d-flex align-items-center gap-2'>
            <div style={{ width: '1px', height: '20px', backgroundColor: '#dee2e6' }} />
            <Dropdown align='end'>
              <Dropdown.Toggle
                variant='none'
                id={`dropdown-client-actions-${client._id}`}
                style={{ background: 'transparent' }}
              >
                <i className='bi bi-three-dots-vertical'></i>
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ zIndex: 9999, position: 'absolute' }}>
                {isAdmin && (
                  <Dropdown.Item
                    onClick={() => {
                      hideKAlert()
                      navigate(`/client/${client._id}/edit`)
                    }}
                  >
                    <i className='bi bi-pencil-fill text-warning'></i> {t('edit')}
                  </Dropdown.Item>
                )}
                <Dropdown.Item onClick={() => onDeactivate(client)}>
                  <i className='bi bi-person-dash'></i>{' '}
                  {clientStatusParam === 'true' ? t('deactivateClient') : t('activateClient')}
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => onDelete(client.clientNumber, client._id)}
                  className='text-danger'
                >
                  <i className='bi bi-trash'></i> {t('deleteClient')}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        ) : (
          <>
            <div style={{ width: '1px', height: '20px', backgroundColor: '#dee2e6' }} />
            <DropdownButton
              id='dropdown-client-actions'
              variant='none'
              title=''
              drop={openDropdownUp ? 'up' : 'down'}
            >
              {isAdmin && (
                <Dropdown.Item
                  onClick={() => {
                    hideKAlert()
                    navigate(`/client/${client._id}/edit`)
                  }}
                >
                  <i className='bi bi-pencil-fill text-warning'></i> {t('edit')}
                </Dropdown.Item>
              )}
              <Dropdown.Item onClick={() => onDeactivate(client)}>
                <i className='bi bi-person-dash'></i>{' '}
                {clientStatusParam === 'true' ? t('deactivateClient') : t('activateClient')}
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => onDelete(client.clientNumber, client._id)}
                className='text-danger'
              >
                <i className='bi bi-trash'></i> {t('deleteClient')}
              </Dropdown.Item>
            </DropdownButton>
          </>
        ))}
      {access && (
        <KAccess
          show={access}
          pin={undefined}
          onConfirm={(pinCode: number) => checkPin(pinCode)}
          onClose={() => setAccess(false)}
          title={t('pinCodeSent')}
        />
      )}

      {notes && (
        <ClientNotesModal
          show={notes}
          clientId={client._id}
          onClose={() => setNotes(false)}
          onNotesChange={count => setHasNotes(count > 0)}
        />
      )}
    </div>
  )
}

export default ClientActionButtons
